import React from 'react';
import classnames from 'classnames';
import Icon from 'shared/components/icon';

interface Props {
  iconType: string;
  padding?: boolean;
  color?: 'blue' | 'grey';
  text: React.ReactNode;
}

const HighlightedText = ({iconType, padding = true, color = 'blue', text}: Props) => (
  <div className={classnames(`college-profile-highlighted-text ${color}`, {padding})}>
    <Icon
      iconType={iconType}
      className={classnames('college-profile-highlighted-text-icon', {padding})}
    />
    <span className="college-profile-highlighted-text-content">{text}</span>
  </div>
);

export default HighlightedText;
